module.exports = __webpack_public_path__ + "img/performance-bg.76e19c7b.jpg";